import { render, staticRenderFns } from "./RsaScalaMinimentalShortModalViewComponent.vue?vue&type=template&id=6ec1f43f"
import script from "./RsaScalaMinimentalShortModalViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaScalaMinimentalShortModalViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports